export default function notify(state = {}, {type,data}) {
  if(type !== 'notify') return state
  return data
}


/** WEBPACK FOOTER **
 ** ./src/app/reducers/notify.js
 **/